import {
    DateShowtimePickerProps,
    defaultDateShowtimePickerPropsWithFilmIds,
    defaultDateShowtimePickerPropsWithoutFilmIds,
} from '@vista-digital/occ-ui/src/lib/components/date-showtime-picker/types/props'
import {
    DateShowtimePickerConfig,
    DateShowtimePickerConfigWithFilmIds,
    DateShowtimePickerConfigWithoutFilmIds,
    defaultDateShowtimePickerConfigWithFilmIds,
    defaultDateShowtimePickerConfigWithoutFilmIds,
} from '@vista-digital/occ-ui/src/lib/components/date-showtime-picker/types/config'
import { DateShowtimePickerInternalAction, defaultDateShowtimePickerDisplayText, FilmThumbnailMediaType } from '@vista-digital/occ-ui'
import { addSelectedSite } from '@vista-digital/occ-domain'
import { urlService, navigationService, cmsDataService } from '../../services'
import { DateShowtimePickerPropsApi } from './models'
import { NavigateFunction } from 'react-router-dom'
import { cmsToOccDisplayText } from '../../../content/utilities/cmsToOccDisplayText'

export interface DateShowtimePickerInitialProps {
    displayText: DateShowtimePickerPropsApi
    filterId?: string
    filmIds?: string[]
    siteIds?: string[]
    // selectedBusinessDate?: string
}

export function getDateShowtimePickerProps(props: DateShowtimePickerInitialProps, navigate: NavigateFunction, ref): DateShowtimePickerProps {
    const { filmIds, siteIds, filterId, displayText } = props
  

    const propsWithFilmIds: DateShowtimePickerProps = {
        ...defaultDateShowtimePickerPropsWithFilmIds,
        siteIds: siteIds,
        filmIds: filmIds,
        config: getDateShowtimePickerConfigWithFilmIds(filterId),
        events: getDateShowtimePickerEvents(siteIds, ref),
        displayText: {
            ...defaultDateShowtimePickerDisplayText,
            ...new DateShowtimePickerPropsApi(),
            nextShowtimeForSiteOnDateMessage: cmsToOccDisplayText(displayText.nextShowtimeForSiteOnDateMessage, navigate, {
                nextScreeningDate: DateShowtimePickerInternalAction.NavigateToDate,
            }),
        },
         // selectedBusinessDate: props.selectedBusinessDate ?? undefined,
    }

    const propsWithoutFilmIds: DateShowtimePickerProps = {
        ...defaultDateShowtimePickerPropsWithoutFilmIds,
        siteIds: siteIds,
        config: getDateShowtimePickerConfigWithoutFilmIds(filterId),
        events: getDateShowtimePickerEvents(siteIds, ref),
        displayText: {
            ...defaultDateShowtimePickerDisplayText,
            ...new DateShowtimePickerPropsApi(),
            nextShowtimeForSiteOnDateMessage: cmsToOccDisplayText(displayText.nextShowtimeForSiteOnDateMessage, navigate, {
                nextScreeningDate: DateShowtimePickerInternalAction.NavigateToDate,
            }),
        },
    }

    return !filmIds ? propsWithoutFilmIds : propsWithFilmIds
}

function getDateShowtimePickerConfigWithFilmIds(filterId): DateShowtimePickerConfigWithFilmIds {
    return {
        ...defaultDateShowtimePickerConfigWithFilmIds,
        filmDetails: {
            show: false,
            mediaType: FilmThumbnailMediaType.Poster,
            headingLevel: 'h2',
        },
        actionButton: {
            show: true,
            showOnMessage: true,
        },
        filmActionLink: {
            show: false,
        },
        ...getDateShowtimePickerConfig(filterId),
    }
}

function getDateShowtimePickerConfigWithoutFilmIds(filterId): DateShowtimePickerConfigWithoutFilmIds {
    return {
        ...defaultDateShowtimePickerConfigWithoutFilmIds,
        siteDetails: {
            show: false,
        },
        allFilmsToggle: {
            show: false,
            initialValue: false,
        },
        actionButton: {
            show: false,
            showOnMessage: true,
        },
        showtimeUrlFactory: showtime => urlService.getShowtimeUrl(showtime),
        filmUrlFactory: film => urlService.getFilmDetailsUrl(film),
        ...getDateShowtimePickerConfig(filterId),
    }
}

function getDateShowtimePickerConfig(filterId: string): Partial<DateShowtimePickerConfig> {
    return {
        showScreenName: true,
        attributeLegend: {
            show: true,
        },
        filter: {
            filterId: filterId || 'test',
            options: {
                event: [],
                genre: [],
                attribute: [],
            },
        },
        componentId: 'date-showtime-picker',
    }
}

function handleFilmDetailsRedirect(film, siteIds) {
    const siteId = siteIds[0]
    if (siteId) addSelectedSite(siteId)
    navigationService.goTo(urlService.getFilmDetailsUrl(film))
}

function getDateShowtimePickerEvents(siteIds, ref) {
    return {
        onActionButtonClicked: () => ref.current.showModal(),
        onFilmActionLinkClicked: film => handleFilmDetailsRedirect(film, siteIds),
        onFilmClicked: film => handleFilmDetailsRedirect(film, siteIds),
        onShowtimeClicked: showtime => navigationService.goTo(urlService.getShowtimeUrl(showtime)),
    }
}

export interface LumosConfiguration {
    baseUrl: string
}
